import moment from 'moment';
import _ from 'lodash';

import { spliceOut } from '../../util/spliceOut.js';
import embedListingView from './embedListingComponent.html';
import './embedListingComponent.css';

export function embedListingComponent() {
	return {
		bindings: {
			templateString: '<',
			showStandardController: '<',
			termCodeDefault: '@',
			termCodeLabel: '@',
		},
		controllerAs: 'vm',
		controller: embedListingComponentCtrl,
		template: embedListingView,
	};
}

export class embedListingComponentCtrl {
	constructor(Api, modal) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.modal = modal;
		// init values
		this.isLoading = true;
	}

	$onInit() {
		this.configs = [];
		this.loadList();
	}

	loadList() {
		this.Api.get('/embed_configs').then(
			configs => {
				this.configs = configs;
				this.isLoading = false;
			},
			error => {
				this.isLoading = false;
				this.error = error;
			}
		);
	}

	add() {
		this.isModalOpen = true;
		const today = moment().format('DD MMM YYYY');
		this.record = {
			label: `My Embed - ${today}`,
			config: {
				// search settings
				limit: 3,
				term_behavior: 'narrow',
				allow_public_access: 0,
				hub_type: 'mine',
				hub_ids: '',
				// view settings
				image_width: 60,
				image_height: 60,
				view_all_label: 'View all posts',
				none_found_message: 'No posts found',
				// advanced settings
				use_padding: 1,
				column_width: 0,
				// preview settings
				iframe_width: 1000,
				iframe_height: 288,
				term_code: this.termCodeDefault,
				controller_code: 'Account',
			},
		};
		this.Api.create('/embed_configs', {
			label: this.record.label,
			config: this.record.config,
		}).then(
			uuid => {
				this.record.uuid = uuid;
				this.configs.unshift(this.record);
			},
			() => {}
		);
	}

	edit(config) {
		this.isModalOpen = true;
		this.record = config;
		// allow_public_access is new, so old embeds won't have it
		// but we want to default old embeds to "No"
		this.record.allow_public_access = this.record.allow_public_access ? 1 : 0;
	}

	delete(config) {
		this.modal.confirm({ text: `Are you sure you want to delete ${_.escape(config.label)}?` }).then(
			() => {
				this.Api.delete(`/embed_configs/${config.uuid}`);
				spliceOut(this.configs, config);
			},
			() => {}
		);
	}

	handleModalClose() {
		this.record = null;
		this.configs = [];
		this.loadList();
	}
}
